/**
 * Weather widget configuration.
 *
 * `DEFAULT_LOCATION` is the current single source of truth for which place we
 * show. When a future location-editor UI lands it should expose the same
 * `WeatherLocation` shape via a hook/atom and pass it into `useWeather`, so the
 * hook / parser / UI don't need to change.
 */
export interface WeatherLocation {
  lat: number;
  lon: number;
  /** IANA timezone — used both for the Open-Meteo `timezone` param and for local-day math. */
  tz: string;
  city: string;
}

export const DEFAULT_LOCATION: WeatherLocation = {
  lat: 60.19148415165085,
  lon: 25.027257989990844,
  tz: 'Europe/Helsinki',
  city: 'Helsinki',
};

/** Maximum number of cells in the rest-of-day mini-strip on the 1×1 tile. */
export const MAX_TILE_STRIP_SLOTS = 6;

/** CSS variable names consumed by chart coloring and accent UI. */
export const WEATHER_COLOR_VARS = {
  temp: '--accent-warning',
  precip: '--accent-info',
  muted: '--text-muted',
  focus: '--border-focus',
} as const;
